import { ShoppingCartService } from '../services/shopping-cart.service';
import { ShoppingCart } from '../models/shopping-cart';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-check-out',
  templateUrl: './check-out.component.html',
  styleUrls: ['./check-out.component.css']
})
export class CheckOutComponent implements OnInit {
  cart$: Observable<ShoppingCart>;
  
  constructor(private shoppingCartService: ShoppingCartService) { }
  
  async ngOnInit() { 
    this.cart$ = await this.shoppingCartService.getCart();
  }
}



// WEBPACK FOOTER //
// G:/MyProjects/Angular/oshop/src/app/check-out/check-out.component.ts